import React from 'react';
import { ArrowLeftRight, Radio } from 'lucide-react';
import { GRAPHQL_LOGO, WEBSOCKET_LOGO } from './protocolLogoPaths';
import GrpcLogo from './GrpcLogo';
import './RequestKindIcon.css';

/**
 * ONE icon per kind of request — the picker tile, the tab, the builder header and the
 * sidebar menu all draw from here, so a WebSocket looks the same wherever it shows up.
 *
 * Where a protocol HAS a logo, that logo is used: GraphQL, WebSocket and gRPC (sources and
 * licences in protocolLogoPaths.js / GrpcLogo.js). HTTP and SSE have none — a glyph from the
 * app's icon library stands in.
 *
 * `size` is the HEIGHT. The WebSocket mark and the gRPC wordmark are wider than tall and
 * keep their proportions. Their ink is black / dark teal in the source; it follows the
 * theme through `currentColor` (RequestKindIcon.css) so it reads on the dark surface.
 */
const GLYPHS = {
  http: { Icon: ArrowLeftRight, color: '#22c55e' },
  sse: { Icon: Radio, color: '#2dd4bf' },
};

export default function RequestKindIcon({ optionId, size = 14, className = '' }) {
  if (optionId === 'graphql') {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill={GRAPHQL_LOGO.color} className={className} aria-hidden focusable="false">
        <path d={GRAPHQL_LOGO.path} />
      </svg>
    );
  }
  if (optionId === 'websocket') {
    const [, , w, h] = WEBSOCKET_LOGO.viewBox.split(' ').map(Number);
    return (
      <svg height={size} width={Math.round((size * w) / h)} viewBox={WEBSOCKET_LOGO.viewBox} fill="currentColor" className={`request-kind-ink ${className}`} aria-hidden focusable="false">
        <path d={WEBSOCKET_LOGO.path} />
      </svg>
    );
  }
  if (optionId === 'grpc') {
    return <GrpcLogo height={size} ink="currentColor" className={`request-kind-ink request-kind-ink--grpc ${className}`} />;
  }
  const { Icon, color } = GLYPHS[optionId] || GLYPHS.http;
  return <Icon size={size} color={color} strokeWidth={2} className={className} aria-hidden />;
}
